import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Scheduling extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.formdata || {}
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { 
          label: 't(Previous)', 
          color: 'blue', 
          basic: true, 
          handler: this._handleBack 
        },
        { 
          label: 't(Done)', 
          color: 'blue', 
          handler: this._handleSubmit 
        }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Website URL)',
              name: 'website_url',
              type: 'urlfield',
              defaultValue: config.website_url
            },
            { 
              label: 't(Business Social Media)',
              instructions: 't(List your business\'s social media profiles for listing on your marketing services. We suggest providing only social media accounts you are active on)',
              type: 'segment',
              fields: [
                { 
                  name: 'identity_facebook',
                  type: 'urlfield',
                  service: 'facebook',
                  placeholder: 't(Enter Facebook URL)', defaultValue: config.identity_facebook 
                },
                { 
                  name: 'identity_instagram',
                  type: 'urlfield',
                  service: 'instagram',
                  placeholder: 't(Enter Instagram URL)', defaultValue: config.identity_instagram 
                },
                { 
                  name: 'identity_linkedin',
                  type: 'urlfield',
                  service: 'linkedin',
                  placeholder: 't(Enter LinkedIn URL)',
                  defaultValue: config.identity_linkedin },
                { 
                  name: 'identity_youtube',
                  type: 'urlfield',
                  service: 'youtube',
                  placeholder: 't(Enter YouTube URL)',
                  defaultValue: config.identity_youtube 
                },
                { 
                  name: 'identity_pinterest',
                  type: 'urlfield',
                  service: 'pinterest',
                  placeholder: 't(Enter Pinterest URL)',
                  defaultValue: config.identity_pinterest 
                },
                { 
                  name: 'identity_tiktok',
                  type: 'urlfield',
                  service: 'tiktok',
                  placeholder: 't(Enter TikTok URL)',
                  defaultValue: config.identity_tiktok 
                },
                { 
                  name: 'identity_threads',
                  type: 'urlfield',
                  service: 'threads',
                  placeholder: 't(Enter Threads URL)',
                  defaultValue: config.identity_threads 
                },
                { 
                  name: 'identity_vimeo',
                  type: 'urlfield',
                  service: 'vimeo',
                  placeholder: 't(Enter Vimeo URL)',
                  defaultValue: config.identity_vimeo 
                },
                { 
                  name: 'identity_x',
                  type: 'urlfield',
                  service: 'x',
                  placeholder: 't(Enter X URL)',
                  defaultValue: config.identity_x 
                }
              ] 
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(config) {
    const { formdata } = this.props
    this.props.onSave({
      ...formdata,
      ...config
    })
  }

}

export default Scheduling
